import React from 'react';
import {
  Button,
  Form,
  Row,
  Col,
  Select,
  Checkbox,
  Popconfirm,
  message
} from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
import { observer, inject } from 'mobx-react';
import styles from './OTA.less';
import Title from '@/components/Title';
import OtaTable from '@/components/OTA/OTATable';
import OTAForm from '../../components/OTA/OTAForm';
import { formItemLayout } from '../../const/FormConst';

@inject('otaStore')
@observer
class OTAComponent extends React.Component {
  constructor(props) {
    super(props);
    this.checked = false;
    this.onCkecked = this.onCkecked.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.successFunc = this.successFunc.bind(this);
  }

  componentDidMount() {
    this.props.otaStore.loadOtaVersion();
    this.props.otaStore.getTargetOta();
    this.props.otaStore.getCurrentOta();
  }
  componentWillUnmount() {
    this.props.form.resetFields();
    this.props.otaStore.version = [];
    this.props.otaStore.targetVersion = [];
    this.props.otaStore.currentVersion = [];
    this.props.otaStore.tableArr = [];
    this.props.otaStore.selectedTableArr = [];
    this.props.otaStore.hasBeenUpdatedArr = [];
    this.props.otaStore.pagesize = 10;
    this.props.otaStore.page_num = 1;
    this.props.otaStore.selectedRowKeys = [];
  }

  onCkecked(e) {
    this.checked = e.target.checked;
  }
  successFunc(update) {
    let dataArr = [...this.props.otaStore.tableArr].map(item => {
      let selectItem = [...this.props.otaStore.selectedTableArr].filter(
        a => a.device_id === item.device_id
      );
      if (selectItem.length && selectItem) {
        item.ota_target = update;
        return item;
      } else {
        return item;
      }
    });
    this.props.otaStore.tableArr = dataArr;
  }
  handleUpdate() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        const formData = new FormData();
        formData.append('ota_version', value.update);
        formData.append(
          'device_id',
          this.props.otaStore.selectedTableArr.map(p => p.device_id).join(',')
        );
        formData.append('install_now', this.checked);
        this.props.otaStore.updateOta(formData).then(json => {
          if (json.code === 200) {
            message.success('更新成功');
            this.successFunc(value.update);
          } else {
            message.error(json.message);
          }
        });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      targetVersion,
      currentVersion,
      version,
      tableArr,
      searchOta
    } = this.props.otaStore;
    return (
      <div className={styles.OTA}>
        <Title titleText={'设备搜索'} />
        <div className={styles.searchContainer}>
          <OTAForm />
        </div>
        <div className={styles.formContainer}>
          <OtaTable data={tableArr} />
        </div>
        <div className={styles.bottomForm}>
          <Form onSubmit={this.handleUpdate}>
            <Row>
              <Col span={7}>
                <FormItem {...formItemLayout} label="更新至版本">
                  {getFieldDecorator('update', {
                    rules: [{ required: true, message: ' ' }]
                  })(
                    <Select placeholder="请选择版本">
                      {(version || []).map(item => (
                        <Option value={item} key={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col span={3} offset={1}>
                <Checkbox onChange={this.onCkecked}>立即升级</Checkbox>
              </Col>
              <Col span={2}>
                <Popconfirm
                  title="是否确认更新版本"
                  onConfirm={this.handleUpdate}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button type="primary">更新</Button>
                </Popconfirm>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}
const OTA = Form.create()(OTAComponent);
export default OTA;



// WEBPACK FOOTER //
// ./src/pages/OTA/OTA.js